/* eslint-disable indent */
import React, { ReactNode } from "react";
import { Drawer } from "@mui/material";
import { drawerStyle } from "./DrawerCustom.style";

interface IDrawerCustomProps {
  open: boolean;
  onClose: () => void;
  children?: ReactNode;
  variant?: "medium" | "large";
}

const DrawerCustom = ({ open, onClose, children, variant = "medium" }: IDrawerCustomProps) => {
  const getDrawerWidth = (variant: "medium" | "large") => {
    switch (variant) {
      case "large":
        return "640px";
      case "medium":
      default:
        return "480px";
    }
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={(theme) => ({
        ...drawerStyle(theme),
        "& .MuiDrawer-paper": {
          ...drawerStyle(theme)["& .MuiDrawer-paper"],
          width: getDrawerWidth(variant),
        },
      })}
      transitionDuration={0}
      id="drawerRight"
    >
      {children}
    </Drawer>
  );
};

export default DrawerCustom;
